import { useEffect, useRef, useState } from "react";
import { notification } from "antd";
import { useDispatch } from "react-redux";

import { getJobShiftSwms } from "../../../../../actions/v2/JobShiftSwmsActions";
import { getJobShiftEmergencyPlans } from "../../../../../actions/v2/JobShiftEmergencyDocumentsActions";
import { Strings } from "../../../../../dataProvider/localize";

export default function useJobShiftEmergencyPlansViewModel({ open, context }) {
  const dispatch = useDispatch();
  const controller = useRef();
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [plans, setPlans] = useState(null);
  const [sections, setSections] = useState({});

  useEffect(() => {
    if (!open) {
      setLoading(false);
      setLoaded(false);
      setPlans(null);
      setSections({});
      return undefined;
    }
    if (!context || !context.jobId || !context.shiftId || !context.swmsId) {
      setLoaded(true);
      return undefined;
    }

    controller.current = new AbortController();
    setLoading(true);
    setLoaded(false);
    Promise.all([
      dispatch(getJobShiftSwms(context, { signal: controller.current.signal })),
      dispatch(getJobShiftEmergencyPlans(context, { signal: controller.current.signal }))
    ]).then(([swms, document]) => {
      const resolvedDocument = swms && swms.document ? swms.document : swms;
      setSections(resolvedDocument && resolvedDocument.sections ? resolvedDocument.sections : {});
      setPlans(document || null);
    }).catch((error) => {
      if (error && error.name === "AbortError") return;
      notification.error({ message: Strings.error_title, description: typeof error === "string" ? error : Strings.network_error, className: "ant-error" });
    }).finally(() => {
      setLoading(false);
      setLoaded(true);
    });

    return () => controller.current && controller.current.abort();
  }, [dispatch, open, context && context.jobId, context && context.shiftId, context && context.swmsId]);

  return { loading, loaded, plans, sections };
}
